'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadingService = function () {
  function LoadingService($rootScope) {
    'ngInject';

    _classCallCheck(this, LoadingService);

    Object.assign(this, { $rootScope: $rootScope });
  }

  _createClass(LoadingService, [{
    key: 'stop',
    value: function stop() {
      this.$rootScope.loadingView = false;
    }
  }, {
    key: 'start',
    value: function start() {
      this.$rootScope.loadingView = true;
    }
  }]);

  return LoadingService;
}();

exports.default = LoadingService;


// WEBPACK FOOTER //
// ./services/loading.service.js